import React, { useEffect, useState } from 'react';
import api from '../api/api';
import { Modal, Message, TableSkeleton } from '../components';
import { kaErrorText } from './kaError';
import { ExtendedHeaders, ExtendedCells } from './KAExtendedFields';

export default function KAMerchantStatusDialog({ selection, onClose, onBack, jiraBaseUrl }) {
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let active = true;
    setLoading(true); setError('');
    api.getKAIssues({ ...selection.filters, page, page_size: 20 }).then(response => {
      if (active) setData({ ...response.data, page });
    }).catch(err => { if (active) setError(kaErrorText(err, '读取状态工单失败')); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [selection, page, retry]);
  const displayedPage = data?.page || 1;
  return <Modal isOpen title={`${selection.merchant} · ${selection.status}`} onClose={onClose} size="large">
    {onBack && <button type="button" className="btn btn-secondary btn-sm" onClick={onBack}>返回全部状态</button>}
    <Message message={error} type="error" />
    <p className="ka-muted">截至 {selection.filters.as_of}，沿用看板已应用的其他筛选条件。共 {data?.total ?? '—'} 张工单。</p>
    <div className="ka-directory-results" aria-busy={loading}>
      {loading && !data && <TableSkeleton rowCount={5} columnCount={5} label="加载状态工单中" />}{loading && data && <span className="ka-directory-loading" role="status">加载中…</span>}
      {!(loading && !data) && <div className="ka-table-scroll ka-directory-table"><table><thead><tr><th>工单</th><th>标题</th><th>类型</th><th>状态</th><th>持续天数</th><ExtendedHeaders fields={data?.extended_fields} /></tr></thead><tbody>
        {(data?.items || []).map(issue => <tr key={issue.key}><td>{jiraBaseUrl ? <a href={`${jiraBaseUrl.replace(/\/$/, '')}/browse/${encodeURIComponent(issue.key)}`} target="_blank" rel="noopener noreferrer">{issue.key}</a> : issue.key}</td><td>{issue.summary} {issue.service_request && <span className="badge badge-default">服务请求</span>}</td><td>{issue.type}</td><td>{issue.status}</td><td>{issue.duration_days == null ? '—' : `${issue.duration_days} 天`}</td><ExtendedCells fields={data?.extended_fields} issue={issue} /></tr>)}
      </tbody></table>{!loading && !error && !data?.items?.length && <p className="ka-muted">当前条件下没有工单。</p>}</div>}
    </div>
    <div className="ka-pagination">
      {error && <button type="button" className="btn btn-secondary btn-sm" disabled={loading} onClick={() => setRetry(value => value + 1)}>重新读取</button>}
      <button type="button" className="btn btn-secondary btn-sm" disabled={loading || displayedPage <= 1} onClick={() => { setPage(displayedPage - 1); setRetry(value => value + 1); }}>上一页</button>
      <span>第 {displayedPage} 页 · {data?.total || 0} 条</span>
      <button type="button" className="btn btn-secondary btn-sm" disabled={loading || displayedPage * 20 >= (data?.total || 0)} onClick={() => { setPage(displayedPage + 1); setRetry(value => value + 1); }}>下一页</button>
    </div>
  </Modal>;
}
